import { Search } from "lucide-react";
import type { InputHTMLAttributes } from "react";

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  onSearchClick?: () => void;
  showButton?: boolean;
}

export function SearchInput({
  onSearchClick,
  showButton = false,
  className = "",
  ...props
}: SearchInputProps) {
  const isDisabled = props.disabled;

  if (showButton) {
    return (
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="flex-1 relative">
          <input
            type="text"
            className={`w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm sm:text-base ${className}`}
            {...props}
          />
        </div>
        <button
          type="button"
          onClick={onSearchClick}
          disabled={isDisabled}
          className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Search size={20} />
          Search
        </button>
      </div>
    );
  }

  return (
    <div className="relative">
      <Search
        size={20}
        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
      />
      <input
        type="text"
        className={`w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base ${className}`}
        {...props}
      />
    </div>
  );
}
